/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_LEAD_RECORDS_META_DATA,
  LOAD_LEAD_RECORDS_META_DATA_SUCCESS,
  LOAD_LEAD_RECORDS_META_DATA_ERROR,
  LOAD_MANAGE_LEAD,
  LOAD_MANAGE_LEAD_SUCCESS,
  LOAD_MANAGE_LEAD_ERROR,
  LOAD_CUSTOM_FIELD,
  LOAD_CUSTOM_FIELD_SUCCESS,
  LOAD_CUSTOM_FIELD_ERROR,
  ADD_MANAGE_LEAD,
  ADD_MANAGE_LEAD_SUCCESS,
  ADD_MANAGE_LEAD_ERROR,
  UPDATE_MANAGE_LEAD,
  UPDATE_MANAGE_LEAD_SUCCESS,
  UPDATE_MANAGE_LEAD_ERROR,
  DELETE_MANAGE_LEAD,
  DELETE_MANAGE_LEAD_SUCCESS,
  DELETE_MANAGE_LEAD_ERROR,
  ADD_LEAD_STATUS,
  ADD_LEAD_STATUS_SUCCESS,
  ADD_LEAD_STATUS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function loadLeadRecordsMetaData() {
  return {
    type: LOAD_LEAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadLeadRecordsMetaDataSuccess(leadRecordsMetaData) {
  return {
    type: LOAD_LEAD_RECORDS_META_DATA_SUCCESS,
    leadRecordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadLeadRecordsMetaDataError(error) {
  return {
    type: LOAD_LEAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//permission list
export function loadManageLead(searchvalue) {
  return {
    type: LOAD_MANAGE_LEAD,
    searchvalue,
  }
}
export function loadManageLeadSuccess(lead_details) {
  return {
    type: LOAD_MANAGE_LEAD_SUCCESS,
    lead_details,
  }
}
export function loadManageLeadError(error) {
  return {
    type: LOAD_MANAGE_LEAD_ERROR,
    error,
  }
}
export function loadCustomFields(customFields) {
  return {
    type: LOAD_CUSTOM_FIELD,
    customFields,
  }
}
export function loadCustomFieldsSuccess(custom_fields) {
  return {
    type: LOAD_CUSTOM_FIELD_SUCCESS,
    custom_fields,
  }
}
export function loadCustomFieldsError(error) {
  return {
    type: LOAD_CUSTOM_FIELD_ERROR,
    error,
  }
}

export function addManageLead(leadDetails) {
  return {
    type: ADD_MANAGE_LEAD,
    leadDetails,
  }
}
export function addManageLeadSuccess() {
  return {
    type: ADD_MANAGE_LEAD_SUCCESS,
  }
}
export function addManageLeadError(error) {
  return {
    type: ADD_MANAGE_LEAD_ERROR,
    error,
  }
}

export function updateManageLead(leadDetails) {
  return {
    type: UPDATE_MANAGE_LEAD,
    leadDetails,
  }
}
export function updateManageLeadSuccess() {
  return {
    type: UPDATE_MANAGE_LEAD_SUCCESS,
  }
}
export function updateManageLeadError(error) {
  return {
    type: UPDATE_MANAGE_LEAD_ERROR,
    error,
  }
}

export function deleteManageLead(leadDetails) {
  return {
    type: DELETE_MANAGE_LEAD,
    leadDetails,
  }
}
export function deleteManageLeadSuccess() {
  return {
    type: DELETE_MANAGE_LEAD_SUCCESS,
  }
}
export function deleteManageLeadError(error) {
  return {
    type: DELETE_MANAGE_LEAD_ERROR,
    error,
  }
}


export function addLeadStatus(leadStatus) {
  return {
    type: ADD_LEAD_STATUS,
    leadStatus,
  }
}
export function addLeadStatusSuccess() {
  return {
    type: ADD_LEAD_STATUS_SUCCESS,
  }
}
export function addLeadStatusError(error) {
  return {
    type: ADD_LEAD_STATUS_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadLeadRecordsMetaData,
  loadLeadRecordsMetaDataSuccess,
  loadLeadRecordsMetaDataError,

  loadManageLead,
  loadManageLeadSuccess,
  loadManageLeadError,
  loadCustomFields,
  loadCustomFieldsSuccess,
  loadCustomFieldsError,

  addManageLead,
  addManageLeadSuccess,
  addManageLeadError,

  updateManageLead,
  updateManageLeadSuccess,
  updateManageLeadError,

  addLeadStatus,
  addLeadStatusSuccess,
  addLeadStatusError,

  deleteManageLead,
  deleteManageLeadSuccess,
  deleteManageLeadError,
}

export default actions
